module.exports = "build/assets/RingsideRegular-Med.e5dc6203.woff2";